var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"axis"},[_c('img',{style:(`top: ${_vm.axisPos.top}; left: ${_vm.axisPos.left}`),attrs:{"id":"crosshair","src":require('@/assets/images/crossHair.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }